import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {cabinetLogout} from "../../store/cabinet/action";
import {TAB_ITEMS, MORE_ITEMS, isActivePath} from "../cabinetShell/config";
import DsIcon from "../_UI/dsIcon";
import LangSwitcher from "../langSwitcher";


const CabinetTabBar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const {t} = useTranslation();

    const [moreOpen, setMoreOpen] = useState(false);
    const moreActive = MORE_ITEMS.some(item => isActivePath(pathname, item.path));

    useEffect(() => {
        setMoreOpen(false);
    }, [pathname]);

    return (
        <>
            {moreOpen ? (
                <div className={Styles.overlay} onClick={() => setMoreOpen(false)}>
                    <div className={Styles.sheet} onClick={e => e.stopPropagation()}>
                        {MORE_ITEMS.map(item => (
                            <div
                                key={item.path}
                                className={`${Styles.sheetItem} ${isActivePath(pathname, item.path) ? Styles.sheetItemActive : ''}`}
                                onClick={() => navigate(`/${item.path}`)}
                            >
                                <DsIcon name={item.icon} size={24}/>
                                <span>{t(item.label)}</span>
                            </div>
                        ))}
                        <div className={Styles.sheetItem} onClick={() => dispatch(cabinetLogout())}>
                            <DsIcon name="logout" size={24}/>
                            <span>{t('Выход')}</span>
                        </div>
                        <div className={Styles.sheetLang}>
                            <LangSwitcher isNotHided={true}/>
                        </div>
                    </div>
                </div>
            ) : null}

            <nav className={Styles.container}>
                <div className={Styles.items}>
                    {TAB_ITEMS.map(item => {
                        const active = isActivePath(pathname, item.path);
                        return (
                            <div
                                key={item.path}
                                className={`${Styles.tab} ${active ? Styles.tabActive : ''}`}
                                onClick={() => navigate(`/${item.path}`)}
                            >
                                <DsIcon name={item.icon} size={24}/>
                                <span>{t(item.tab)}</span>
                                {active ? <i className={Styles.indicator}/> : null}
                            </div>
                        );
                    })}
                    <div
                        className={`${Styles.tab} ${moreActive || moreOpen ? Styles.tabActive : ''}`}
                        onClick={() => setMoreOpen(!moreOpen)}
                    >
                        <DsIcon name="more" size={24}/>
                        <span>{t('Ещё')}</span>
                        {moreActive ? <i className={Styles.indicator}/> : null}
                    </div>
                </div>
            </nav>
        </>
    );
};

export default CabinetTabBar;
